export const tr = {
    'error-display-conditions': 'Hata oluştu. Lütfen, tekrar deneyin.',
    'fetch-moderation-reject-reasons-error': 'Reddedilme nedenleri alınamadı. Tekrar deneyin',
    'many-image-can-load': 'Bu gruba sadece {count} görsel yüklenebilir',
    'not-loaded-files-button': 'Tamam',
    'not-loaded-files-title': 'Aşağıdaki dosyalar yüklenmedi',
    'one-image-can-load': 'Bu gruba sadece 1 görsel yüklenebilir',
    'some-image-can-load': 'Bu gruba sadece {count} görsel yüklenebilir',
    'warning-about-changes': 'Değişiklikleriniz kaydedilmeyecek. Devam etmek istiyor musunuz?'
};
